import React from 'react'

import {
  AlignItems,
  Box,
  Display,
  FlexDirection,
  Image,
  JustifyContent,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

type TwoColumnLayoutProps = {
  image: {
    src: string
    alt: string
  }
  children: React.ReactNode
}

const ImageWithLimitedHeight = withCitrusTheme(Image, (theme) => {
  const breakpointToLarge = `@media (max-width: ${theme.tokens.breakpoints[2]})`
  const breakpointFromLarge = `@media (min-width: ${theme.tokens.breakpoints[2]})`

  return {
    [breakpointToLarge]: {
      maxHeight: '457px',
    },
    [breakpointFromLarge]: {
      maxHeight: '648px',
    },
  }
})

export function TwoColumnLayout({ image, children }: TwoColumnLayoutProps) {
  return (
    <Box
      display={Display.Flex}
      alignItems={AlignItems.FlexStart}
      justifyContent={JustifyContent.SpaceEvenly}
      flexDirection={[FlexDirection.Column, null, null, FlexDirection.Row]}
      paddingH={[8, 20]}
      paddingV={16}
      paddingBottom={6}
      gap={[4, 8]}
      maxWidth="1200px"
      style={{ margin: '0 auto' }}
    >
      <Box width={[null, null, null, '600px']} paddingBottom={[3, 4]}>
        {children}
      </Box>
      <Box width={['100%', null, null, '600px']} paddingBottom={[3, 4]}>
        <ImageWithLimitedHeight
          style={{ borderRadius: '8px' }}
          fit="cover"
          alt={image.alt}
          src={image.src}
        />
      </Box>
    </Box>
  )
}
